"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
const functions_1 = require("../../functions");
function propertyDefinition(pvs) {
    const inputHumidities = (0, functions_1.getInputHumidities)(pvs);
    return [
        ...inputHumidities.map((_, i) => ({
            sort_no: i,
            name: (0, functions_1.inputHumidityName)(i),
            group: "",
            quantity: "RelativeHumidity",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.fromString("stepproperty=2"),
            value: [],
            fieldName: functions_1.inputHumidityPrefix,
            conversionParameters: {
                pressure: property_1.PropertyValueSet.getAmount("airinputspressure", pvs),
                temperature: property_1.PropertyValueSet.getAmount("airinputstemperature", pvs)
            }
        }))
    ];
}
//# sourceMappingURL=input-humidities-definition.js.map